// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"39caf276","453":"9067ceb7","865":"5a7c74a9"}[chunkId] + ".chunk.js";
};